import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import moment from "moment";
import { DialogBase } from 't4core';
import { T4_ServiceDialog } from "../serviceDialog/serviceDialog";


@Component({
  selector: 'svc-addActionDialog',
  templateUrl: 'addActionDialog.html',
  styleUrls: ['./addActionDialog.css']
})


export class AddActionDialog extends DialogBase implements OnInit {

  public comment: string = "";
  public selectedDate: moment.Moment = moment();

  constructor(
    public dialogRef: MatDialogRef<T4_ServiceDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super("AddActionDialog");
;
  }

  async ngOnInit() {
    this.selectedDate.add(2, 'week');
  }



}
